import React, { useState } from "react";
import BudgetTemplateForm from "./BudgetTemplateForm";
import BudgetTemplateList from "./BudgetTemplateList";

const BudgetTemplate = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <BudgetTemplateForm
          addForm={setFromIsShown}
          update={upData}
          sId={serviceId}
        />
      ) : (
        <BudgetTemplateList
          addForm={setFromIsShown}
          update={setUpData}
          sId={setServiceId}
        />
      )}
    </>
  );
};

export default BudgetTemplate;
